import { fromJS } from 'immutable';

import { SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAILED } from './types';

export const initialState = fromJS({
  loading: false,
  error: null,
});

export default (state = initialState, action: { type: string; value?: boolean; error?: Error }) => {
  switch (action.type) {
    case SUBMIT:
      return state.merge({ loading: true, error: null });

    case SUBMIT_SUCCESS:
      return state.set('loading', false);

    case SUBMIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};
